import { SEND_EMAIL_TOOL_NAME } from "./toolCatalog";

export const COMPLETION_NOTIFICATION_TYPES = [
  { value: "NONE", label: "None" },
  { value: "EMAIL", label: "Email" },
  { value: "SLACK", label: "Slack" },
  { value: "WEBHOOK", label: "Custom POST" },
];

export const EMAIL_RESPONSE_POLICY_PRESET_ALWAYS_REPLY_EMAIL =
  "ALWAYS_REPLY_EMAIL";
export const DEFAULT_EMAIL_RESPONSE_POLICY_PRESET =
  EMAIL_RESPONSE_POLICY_PRESET_ALWAYS_REPLY_EMAIL;

export const EMAIL_RESPONSE_POLICY_PRESETS = [
  {
    value: EMAIL_RESPONSE_POLICY_PRESET_ALWAYS_REPLY_EMAIL,
    label: "Always reply back via email",
    description:
      "Use email as the default response channel for inbound email messages.",
  },
  {
    value: "ONLY_REPLY_CHAT",
    label: "Only reply in chat",
    description:
      "Never send outbound email unless a manager explicitly asks for it.",
  },
  {
    value: "AWAIT_INSTRUCTIONS_BEFORE_EMAIL",
    label: "Await instructions before emailing",
    description:
      "Draft in chat first, then wait for explicit instruction before sending email.",
  },
];

export const ensureSendEmailEnabledForPolicy = (enabledTools, policyPreset) => {
  const normalizedTools = Array.isArray(enabledTools)
    ? enabledTools.filter(
        (toolName) => typeof toolName === "string" && toolName
      )
    : [];
  const dedupedTools = [...new Set(normalizedTools)];
  if (
    policyPreset === EMAIL_RESPONSE_POLICY_PRESET_ALWAYS_REPLY_EMAIL &&
    !dedupedTools.includes(SEND_EMAIL_TOOL_NAME)
  ) {
    dedupedTools.push(SEND_EMAIL_TOOL_NAME);
  }
  return dedupedTools;
};

export const buildWebhookPayloadPreview = (agentName) => ({
  event: "agent_response_completed",
  agent: {
    id: "<agent_id>",
    name: agentName || "<agent_name>",
  },
  session: {
    id: "<chat_session_id>",
    status: "COMPLETED",
    iterationsUsed: 3,
    source: "CHAT",
    workflowSessionId: "<workflow_session_id_or_null>",
    completedAt: "2026-02-19T20:11:27Z",
    startedAt: "2026-02-19T20:10:52Z",
  },
  response: {
    preview: "<assistant_response_preview>",
    length: 138,
  },
  links: {
    agentSession:
      "https://app.workflow86.com/agents/<agent_id>?sessionId=<chat_session_id>",
    workflowSession:
      "https://app.workflow86.com/project/logs/progress_view/<project_id>/<workflow_session_id>?test=false",
  },
});
